import React from "react";
import "../styles/Home.css";
import Servicios from "../components/Servicios";
import WhatsAppButton from "../components/WhatsAppButton";
import Portada from "../components/Portada";
import { Box } from "@mui/material";
import ContactForm from "../components/ContactForm";
import Nosotros from "../components/Nosotros";

function Home() {
 
  return (
    <div className="home">
    
        <Box>
          <Portada />
          <Nosotros />
          <Servicios />
         <WhatsAppButton id="btn-whatsapp" srOnly='Whatsapp general' message ="Hola, necesito información sobre un servicio"/>
          <ContactForm placeholder="" id="contacto" />
        </Box>
    
     
    </div>
    
  );
}

export default Home;
